import React, { useState, useRef, useEffect } from 'react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { Icon } from '@plone/volto/components';

export type DropdownMenuProps = {
  title?: string;
  icon?: any;
  links?: { title: string; href: string }[];
  children?: React.ReactNode;
};

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  title,
  icon,
  links,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div
      className={`header-dropdown-menu ${isOpen ? 'open' : ''}`}
      ref={dropdownRef}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button
        type="button"
        className="header-dropdown-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-haspopup="true"
        aria-expanded={isOpen}
      >
        {icon && <Icon name={icon} size="20px" />}
        {title && <span>{title}</span>}
        {children}
        <svg
          className={`dropdown-caret ${isOpen ? 'open' : ''}`}
          width="20"
          height="20"
          viewBox="0 0 24 24"
        >
          <path d="M7 10l5 5 5-5z" fill="currentColor" />
        </svg>
      </button>
      {isOpen && (
        <ul className="header-dropdown-list">
          {links &&
            links.map((link) => (
              <li key={link.href}>
                <UniversalLink
                  href={link.href}
                  onClick={() => setIsOpen(false)}
                >
                  {link.title}
                </UniversalLink>
              </li>
            ))}
        </ul>
      )}
    </div>
  );
};

export default DropdownMenu;
